import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './ResponsiveMenu.css';

const Menu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(null);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setShowDropdown(null);
  };

  const toggleDropdown = (menu) => {
    setShowDropdown(showDropdown === menu ? null : menu);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar" ref={menuRef}>
      <Link to="/" onClick={closeMenu}>
        <img
          className="navbar-brand"
          src="/images/agentBo-white-background-8.png"
          alt="Logo"
        />
      </Link>

      <div className="hamburger" onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      <ul className={`nav-links ${isOpen ? 'open' : ''}`}>

        <li><Link to="/" onClick={closeMenu}>Home</Link></li>

        <li><Link to="/about" onClick={closeMenu}>About</Link></li>

        {/* FEATURES */}
        <li
          onClick={() => toggleDropdown('Features')}
          onMouseEnter={() => setShowDropdown('Features')}
          onMouseLeave={() => setShowDropdown(null)}
          className="has-dropdown"
        >
          <span className="nav-link">Features</span>

          {showDropdown === 'Features' && (
            <ul className="dropdown">
              <li><Link to="/chatbots" onClick={closeMenu}>Chatbots</Link></li>
              <li><Link to="/livechat" onClick={closeMenu}>Live Chat</Link></li>
              <li><Link to="/whatsapp-features" onClick={closeMenu}>Whatsapp Features</Link></li>
            </ul>
          )}
        </li>

        {/* INDUSTRY */}
        <li
          onClick={() => toggleDropdown('Industry')}
          onMouseEnter={() => setShowDropdown('Industry')}
          onMouseLeave={() => setShowDropdown(null)}
          className="has-dropdown"
        >
          <span className="nav-link">Industry Use-cases</span>

          {showDropdown === 'Industry' && (
            <ul className="dropdown">
              <li><Link to="/education" onClick={closeMenu}>Education</Link></li>
              <li><Link to="/insurance" onClick={closeMenu}>Insurance</Link></li>
              <li><Link to="/healthcare" onClick={closeMenu}>HealthCare</Link></li>
              <li><Link to="/ecommerce" onClick={closeMenu}>Ecommerce</Link></li>
            </ul>
          )}
        </li>

        <li><Link to="/contact-us" onClick={closeMenu}>Contact Us</Link></li>

        <Link to="/Shedule-a-demo" className="navbutton" onClick={closeMenu}>
            Schedule a demo
        </Link>

      </ul>
    </nav>
  );
};

export default Menu;